export const AF_CHANNELS = [
  'inapp_display', 'inapp_banner', 'banner', 'inapp', 'display',
  'banner320X50', 'banner300X250', 'in-app', 'mobile_banner',
  'mobile_display', 'InApp_Display',
]

export const pickChannel = () => AF_CHANNELS[Math.floor(Math.random() * AF_CHANNELS.length)]

export const dateSuffix = () => {
  const now = new Date()
  const dd = String(now.getDate()).padStart(2, '0')
  const mm = String(now.getMonth() + 1).padStart(2, '0')
  const r = Math.floor(Math.random() * 10)
  return `${dd}${mm}${r}`
}

export const buildAdsetAd = (codes) => {
  const pool = [...codes]
  const i = Math.floor(Math.random() * pool.length)
  const adsetCode = pool.splice(i, 1)[0]
  const adCode = pool[Math.floor(Math.random() * pool.length)]
  const suffix = dateSuffix()
  return { adset: `${adsetCode}${suffix}`, ad: `${adCode}${suffix}` }
}

export const validateBundle = (os, raw) => {
  const v = raw.trim()
  if (!v) return 'Bundle ID is required.'
  if (os === 'ios') {
    if (!/^\d+$/.test(v)) return 'iOS expects the numeric App Store ID (digits only), e.g. 284882215.'
  } else if (!/^[a-zA-Z][a-zA-Z0-9_]*(\.[a-zA-Z0-9_]+)+$/.test(v)) {
    return 'Android expects a package name, e.g. com.company.app.'
  }
  return ''
}

export const buildUrl = ({
  os,
  bundleId,
  agency,
  pid,
  channel,
  campaignName,
  costModel,
  isRetargeting,
  additionalParams,
  adset,
  ad,
  isVTA,
}) => {
  const host = isVTA ? 'https://impression.appsflyer.com/' : 'https://app.appsflyer.com/'
  const appPart = os === 'ios' ? 'id' + bundleId.trim() : bundleId.trim()

  const p = []
  p.push(`pid=${encodeURIComponent(pid)}`)
  if (agency.trim()) p.push(`af_prt=${encodeURIComponent(agency.trim())}`)
  p.push('af_siteid={pid}')
  p.push('af_c_id={offer_id}')
  p.push(isVTA ? 'af_viewthrough_lookback=24h' : 'af_click_lookback=7d')
  p.push('clickid={clickid}')
  p.push(`c=${encodeURIComponent(campaignName.trim())}`)
  p.push('af_sub_siteid={sub6}')
  p.push(`af_channel=${channel}`)
  p.push('af_ad_type=banner')
  p.push(`af_adset=${adset}{sub7}`)
  p.push(`af_adset_id=${adset}`)
  p.push(`af_ad=${ad}{sub2}`)
  p.push(`af_ad_id=${ad}`)
  p.push('af_media_type=app')
  p.push('af_model={device_model}')
  p.push('af_cost_currency=usd')
  p.push(`af_cost_model=${costModel}`)
  p.push('af_ua={device_ua}')
  p.push('af_ip={ip}')
  p.push(os === 'android' ? 'advertising_id={sub5}' : 'idfa={sub5}')
  p.push('af_os_version={os_version}')
  p.push('af_language={language}')
  p.push(`is_retargeting=${isRetargeting === 'yes' ? 'true' : 'false'}`)
  if (isRetargeting === 'yes') {
    p.push('af_reengagement_window=30d')
    p.push('af_inactivity_window=10d')
  }
  p.push('af_ad_format=image')

  let url = `${host}${appPart}?${p.join('&')}`
  const extra = additionalParams.trim().replace(/^[?&\s]+/, '')
  if (extra) url += '&' + extra
  return url
}
